module.exports = __webpack_public_path__ + "img/l-cb6-000-2.ba700a42.gif";